import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AsyncNotificationStatus } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { DataHook, Truncated } from './components';
import { GenericNotification } from './GenericNotification';

export const deleteForeverNotification =
  ({ items }) =>
  ({ notification }) =>
    (
      <DataHook dataHook="notification.delete-forever" notification={notification}>
        <GenericNotification
          notification={notification}
          text={
            <FormattedMessage
              id={
                notification.status === AsyncNotificationStatus.Pending
                  ? 'files-manager.delete-forever-notification.pending'
                  : 'files-manager.delete-forever-notification.done'
              }
              values={{
                itemsCount: items.length,
                itemName: <Truncated>{items[0].name}</Truncated>,
              }}
            />
          }
        />
      </DataHook>
    );
